<template>
    <div class="concat_us">
        <!--联系信息-->
        <div class="title_div">{{ $t('header_menu.contact') }}</div>

        <div class="info_list">
            <a :href="'tel:' + data.phone" class="info_item">
                <span class="info_icon"><i class="el-icon-phone"></i></span>
                <span class="info_text">{{ data.phone }}</span>
            </a>

            <a :href="waLink(data.phone)" target="_blank" rel="noopener" class="info_item">
                <span class="info_icon"><i class="el-icon-chat-dot-round"></i></span>
                <span class="info_text">{{ data.phone }}</span>
            </a>

            <a :href="'mailto:' + data.email" class="info_item">
                <span class="info_icon"><i class="el-icon-message"></i></span>
                <span class="info_text">{{ data.email }}</span>
            </a>

            <div class="info_item">
                <span class="info_icon"><i class="el-icon-location"></i></span>
                <span class="info_text">{{ data.address }}</span>
            </div>
        </div>

        <!--社媒链接-->
        <div class="social_line">
            <i class="iconfont icon-facebook"></i>
        </div>
    </div>
</template>
<script>
import {reqListConcat} from "@/api/business/Concat";

export default {
    name: "MobileConcatUs",
    async created() {
        await this.loadConcat();
    },
    methods: {
        async loadConcat(){
            let {data}=await reqListConcat({type:2})
            this.data=data;
        },
        // 由电话号生成 WhatsApp 链接
        waLink(phone) {
            const num = (phone || '').replace(/[^\d]/g, '');
            return num ? 'https://wa.me/' + num : 'javascript:void(0)';
        }
    },
    data() {
        return {
            data:{
                phone:"",
                email:"",
                address:"",
            },
        }
    },
}
</script>
<style scoped lang="scss">
.concat_us {
    background: transparent;
    color: rgba(255, 255, 255, .82);
    /* 与上方 .block 的 padding 一致，确保标题下划线对齐 */
    padding: 18px 20px;
}
.title_div {
    font-size: 18px;
    font-weight: 700;
    color: var(--wood);
    letter-spacing: 1px;
    text-transform: uppercase;
    padding-bottom: 10px;
    margin-bottom: 14px;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 28px;
        height: 2px;
        background: var(--wood);
    }
}
.info_list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}
.info_item {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, .82);
}
.info_icon {
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: rgba(255, 255, 255, .12);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff;
    margin-right: 12px;
}
.info_text {
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}
.social_line {
    height: 44px;
    line-height: 44px;
    margin-top: 8px;
    font-size: 22px;
    color: rgba(255, 255, 255, .7);

    .iconfont:hover {
        color: var(--wood);
    }
}
</style>
